<template>
  <div id="registrarServicio">
    <div class="section">
      <div class="columns">
        <div class="column">
          <div class="card">
            <div class="card-header">
              {{ servicio }}
            </div>
            <div class="card-content">
              <b-tabs v-model="activeTab">
                <b-tab-item label="cedula">
                  <span class="tag is-success is-medium"
                    >Ultima cédula {{ lastcedula }}</span
                  >
                  <FormulateInput
                    ref="cedulaID"
                    type="text"
                    v-model="cedula"
                    name="cedula"
                    label="Cédula usuario"
                    validation="required"
                    v-on:keyup.enter="onEnter"
                    :disabled="true"
                  />
                  <br />
                  <div class="columns">
                    <div class="column">
                      <b-button
                        type="is-primary"
                        class="mx-1"
                        @click="addText('1')"
                        >1</b-button
                      >
                      <b-button
                        type="is-primary"
                        class="mx-1"
                        @click="addText('2')"
                        >2</b-button
                      >
                      <b-button
                        type="is-primary"
                        class="mx-1"
                        @click="addText('3')"
                        >3</b-button
                      >
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column">
                      <b-button
                        type="is-primary"
                        class="mx-1"
                        @click="addText('4')"
                        >4</b-button
                      >
                      <b-button
                        type="is-primary"
                        class="mx-1"
                        @click="addText('5')"
                        >5</b-button
                      >
                      <b-button
                        type="is-primary"
                        class="mx-1"
                        @click="addText('6')"
                        >6</b-button
                      >
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column">
                      <b-button
                        type="is-primary"
                        class="mx-1"
                        @click="addText('7')"
                        >7</b-button
                      >
                      <b-button
                        type="is-primary"
                        class="mx-1"
                        @click="addText('8')"
                        >8</b-button
                      >
                      <b-button
                        type="is-primary"
                        class="mx-1"
                        @click="addText('9')"
                        >9</b-button
                      >
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column">
                      <b-button type="is-warning" class="mx-1" @click="back()">
                        C
                      </b-button>
                      <b-button
                        type="is-primary"
                        class="mx-1"
                        @click="addText('0')"
                        >0</b-button
                      >
                      <b-button
                        type="is-success"
                        class="mx-1"
                        @click="register('cedula')"
                        >R</b-button
                      >
                    </div>
                  </div>
                </b-tab-item>
                <b-tab-item label="Barras">
                  <span
                    v-if="QrRegistered % 2 === 0"
                    class="tag is-success is-medium"
                    >Registrados {{ QrRegistered }}</span
                  >
                  <span v-else class="tag is-warning is-medium"
                    >Registrados {{ QrRegistered }}</span
                  >
                  <FormulateInput
                    ref="barrasID"
                    type="text"
                    v-model="barcode"
                    name="cedula"
                    label="QR y Barcode"
                    validation="required"
                    v-on:keyup.enter="onEnterNoRegistrado"
                    :disabled="true"
                  />
                  <StreamBarcodeReader
                    v-if="activeTab === 1"
                    @decode="onDecode"
                    @loaded="onLoaded"
                  ></StreamBarcodeReader>
                </b-tab-item>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="card">
            <header class="card-header">
              <h2 class="subtitle mx-2">Registros</h2>
              <button
                class="button mx-1"
                @click="readDbData"
                :disabled="!refreshBtnVisible"
              >
                <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z"
                  />
                </svg>
              </button>
              inicial: {{ initdate }} - final: {{ enddate }}
            </header>
            <div class="card-content">
              <p>
                <b-field grouped group-multiline
                  ><div class="control is-flex">
                    <b-switch v-model="isPaginated">Paginar</b-switch>
                  </div>
                  <b-select v-model="perPage" :disabled="!isPaginated">
                    <option value="5">5 por pagina</option>
                    <option value="10">10 por pagina</option>
                    <option value="15">15 por pagina</option>
                    <option value="20">20 por pagina</option>
                  </b-select>

                  <b-select
                    v-model="paginationPosition"
                    :disabled="!isPaginated"
                  >
                    <option value="bottom">Final paginación</option>
                    <option value="top">Inicio paginación</option>
                    <option value="both">Ambos</option>
                  </b-select>
                  <button class="button is-primary" @click="exportar">
                    Exportar
                  </button>
                  <button class="button is-primary" @click="pdfexport">
                    pdf
                  </button>
                </b-field>
                <b-table
                  id="my-table"
                  :data="tableData"
                  :columns="columns"
                  :paginated="isPaginated"
                  :per-page="perPage"
                  :pagination-position="paginationPosition"
                ></b-table>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import db from "../dbdexie";
import { ExportToCsv } from "export-to-csv";
import { StreamBarcodeReader } from "vue-barcode-reader";
var dayjs = require("dayjs");
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  data() {
    return {
      refreshBtnVisible: true,
      barcode: "",
      lastresult: "None",
      registering: false,
      activeTab: 0,
      counter: 0,
      isSwitched: false,
      message: "",
      isActive: false,
      servicio: null,
      razonsocial: "",
      ubicacion: "",
      userQR: "",
      cedula: "",
      lastcedula: "-",
      isPaginated: true,
      perPage: 10,
      paginationPosition: "bottom",
      tableData: [],
      columns: [
        {
          field: "id",
          label: "ID",
          width: "40",
          numeric: true,
        },
        {
          field: "idususario",
          label: "Identificacion usuario",
        },
        {
          field: "qr",
          label: "Código QR",
        },
        {
          field: "fecha",
          label: "Fecha",
        },
        {
          field: "hora",
          label: "Hora",
        },
        {
          field: "razonsocial",
          label: "Razon Social",
          centered: true,
        },
        {
          field: "sitio",
          label: "Ubicación",
        },
        {
          field: "servicio",
          label: "Servicio prestado",
        },
      ],
      externalScript: null,
      externalScript2: null,
      initdate: "",
      enddate: "",
      QrRegistered: 0,
    };
  },
  computed: {
    ColumsDesc: function () {
      var result = [];
      this.columns.forEach(function (val) {
        if (!["razonsocial", "sitio"].includes(val.field)) {
          result.push({ header: val.field, dataKey: val.field });
        }
      });
      return result;
    },
    ColumnStyles: function () {
      return { qr: { cellWidth: "50" }, idusuario: { cellWidth: "50" } };
    },
  },
  watch: {
    userQR: function (value) {
      if (value === undefined || value === "") {
        return;
      }
      this.register("qr");
    },
  },
  components: {
    StreamBarcodeReader,
  },
  beforeMount: async function () {
    this.servicio = this.$route.params.tiposervicio || "alimentacion";
    const data = JSON.parse(localStorage.getItem("formValue") || "{}");
    this.razonsocial = data.razonsocial;
    this.ubicacion = data.ubicacion;
    // this.readDbData()
  },
  methods: {
    onDecode(result) {
      if (this.registering) {
        return;
      }
      if (result === this.lastresult) {
        return;
      }
      this.registering = true;
      this.barcode = result;
      this.registebarcode();
    },
    onLoaded() {
      console.log("loaded");
    },
    addText: async function (value) {
      this.cedula = this.cedula + value;
    },
    back: async function () {
      this.cedula = "";
      //if (this.cedula.length > 0) {
      //  this.cedula = this.cedula.slice(0, this.cedula.length - 1)
      // }
    },
    onEnter: function () {
      this.register("cedula");
    },
    pdfexport: function () {
      var doc = new jsPDF("landscape");
      doc.setFontSize(12);
      doc.text("Reporte entregas casino by selobu@gmail.com", 15, 10);
      doc.text(this.razonsocial + " - " + this.ubicacion, 15, 15);
      doc.autoTable({
        body: this.tableData,
        columns: this.ColumsDesc,
        margin: { left: 5, right: 5, top: 5 },
        startY: 20,
      });
      doc.save("casino data.pdf");
    },
    exportar: async function () {
      const options = {
        fieldSeparator: ";",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        showTitle: true,
        title: "Export",
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
        // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
      };

      const csvExporter = new ExportToCsv(options);

      csvExporter.generateCsv(this.tableData);
    },
    registebarcode() {
      this.registering = true;
      if (this.barcode.length < 5) {
        this.message =
          "Código inválido, genere el código de cada usuario desde le menú de inicio de la aplicacion";
        this.isActive = true;
        this.registering = false;
        return;
      }
      const nuevo = this;
      if (nuevo.lastresult === nuevo.barcode) {
        return;
      }
      nuevo.lastresult = nuevo.barcode;
      // current date in ISO8601
      var day = dayjs();
      db.registros
        .add({
          timestamp: day.format(),
          fecha: day.format("DD/MM/YYYY"),
          hora: day.format("HH:mm:ss"),
          razonsocial: this.razonsocial,
          sitio: this.ubicacion,
          idususario: "",
          qr: this.barcode,
          servicio: this.servicio,
        })
        .then(function (res) {
          console.log("Exitoso");
          nuevo.cedula = "";
          nuevo.barcode = "None";
          // nuevo.readDbData()
          nuevo.registering = false;
          nuevo.QrRegistered += 1;
          res;
        })
        .catch(function (error) {
          nuevo.registering = false;
          console.log({ error });
        });
    },
    register: function (value) {
      this.registering = true;
      if (value === undefined || value === "") {
        this.registering = false;
        return;
      } else if (value === "cedula" && this.cedula === "") {
        this.registering = false;
        return;
      } else if (value === "qr" && this.userQR.length !== 36) {
        this.registering = false;
        this.message =
          "Código inválido, genere el código de cada usuario desde le menú de inicio de la aplicacion";
        this.isActive = true;
        return;
      }
      const nuevo = this;
      if (value === "qr" && nuevo.lastresult === nuevo.userQR) {
        this.registering = false;
        return;
      }
      if (value === "cedula") {
        this.lastcedula = this.cedula;
      }
      nuevo.lastresult = nuevo.userQR;
      console.log("preparing to register");
      var day = dayjs();
      db.registros
        .add({
          timestamp: day.format(),
          fecha: day.format("DD/MM/YYYY"),
          hora: day.format("HH:mm:ss"),
          razonsocial: this.razonsocial,
          sitio: this.ubicacion,
          idususario: value === "cedula" ? this.cedula : "",
          qr: value === "qr" ? this.userQR : "",
          servicio: this.servicio,
        })
        .then(function (res) {
          // console.log('Exitoso')
          nuevo.cedula = "";
          nuevo.userQR = "None";
          // nuevo.readDbData()
          nuevo.registering = false;
          res;
        })
        .catch(function (error) {
          nuevo.registering = false;
          console.log({ error });
        });
      //this.$refs.cedulaID.focus()
    },
    readDbData: async function () {
      this.refreshBtnVisible = false;
      var initdate = dayjs().subtract(3, "day");
      var enddate = dayjs().add(1, "day");
      const nuevo = this;
      db.registros
        .where("timestamp")
        .between(initdate.format(), enddate.format())
        .and(function (friends) {
          return friends.servicio === nuevo.servicio;
        })
        .reverse()
        .limit(50)
        .toArray()
        .then(function (response) {
          nuevo.tableData = response;
          nuevo.refreshBtnVisible = true;
        })
        .catch(function (error) {
          console.log({ error });
          nuevo.refreshBtnVisible = true;
        });
      this.initdate = initdate.format("DD/MM/YYYY");
      this.enddate = enddate.format("DD/MM/YYYY");
    },
  },
};
</script>
